var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 125 100",
    viewBox: "0 0 125 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#1A171B;}\r\n\t.st1{fill:#EE7203;}")), /*#__PURE__*/React.createElement("rect", {
    x: 19.393,
    y: 6.5863,
    width: 87.046,
    height: 87.046,
    fillOpacity: 0,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.193 53.758 22.785 25.989 45.926-62.125",
    fillOpacity: 0,
    stroke: "#ee7203",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    style: {
      paintOrder: "stroke fill markers"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.5c11bbb043fdd30b92e7d2b5889bd789.svg";
export { ForwardRef as ReactComponent };